<mat-drawer-container class="audit-drawer-container">
  <mat-drawer-content class="audit-drawer-content">
    <ng-content></ng-content>
  </mat-drawer-content>
  <!-- audits drawer -->
  <mat-drawer
    #audits
    class="audit-drawer"
    [opened]="showAuditDrawer$ | async"
    (openedChange)="drawerOpenChanged($event)"
    position="end"
    mode="over"
  >
    <div class="audit-drawer-header">
      <ng-container [ngSwitch]="selectedAuditScreen">
        <h2 *ngSwitchCase="auditScreen.AircraftEvent">Aircraft Event Audit</h2>
        <h2 *ngSwitchCase="auditScreen.AircraftProfile">Aircraft Profile Audit</h2>
        <h2 *ngSwitchCase="auditScreen.PersonProfile">Person Profile Audit</h2>
        <h2 *ngSwitchCase="auditScreen.TrainingRequirementProfile">Training Requirements Audit</h2>
        <h2 *ngSwitchCase="auditScreen.StaffEvent">Staff Event Audit</h2>
        <h2 *ngSwitchCase="auditScreen.CompanyProfile">Company Profile Audit</h2>
        <h2 *ngSwitchCase="auditScreen.ScheduledTrip">Scheduled Trip Audit</h2>
        <h2 *ngSwitchCase="auditScreen.DeletedTrips">Deleted Trips Audit</h2>
        <h2 *ngSwitchCase="auditScreen.TripManager">Trip Manager Audit</h2>
        <h2 *ngSwitchCase="auditScreen.PostedFlight">Posted Flight Audit</h2>
        <h2 *ngSwitchCase="auditScreen.SimulatedFlight">Simulated Flight Audit</h2>
        <h2 *ngSwitchCase="auditScreen.Expense">Expense Audit</h2>
        <h2 *ngSwitchCase="auditScreen.DeletedExpenses">Deleted Expenses Audit</h2>
        <h2 *ngSwitchCase="auditScreen.FleetOverview">Fleet Overview Audit</h2>
        <h2 *ngSwitchCase="auditScreen.UserManagement">User Management Audit</h2>
        <h2 *ngSwitchCase="auditScreen.RoleManagement">Role Management Audit</h2>
      </ng-container>

      <div class="close-drawer-container">
        <a mat-button (click)="closeDrawer()">
          <mat-icon>close</mat-icon>
        </a>
      </div>
    </div>

    <div *ngIf="showAuditDrawer$ | async" class="audit-drawer-content">
      <ng-container [ngSwitch]="selectedAuditScreen">
        <sd-portal-aircraft-profile-audit *ngSwitchCase="auditScreen.AircraftProfile">
        </sd-portal-aircraft-profile-audit>
        <sd-portal-person-profile-audit
          *ngSwitchCase="auditScreen.PersonProfile"
        ></sd-portal-person-profile-audit>
        <sd-portal-training-requirement-profile-audit
          *ngSwitchCase="auditScreen.TrainingRequirementProfile"
        >
        </sd-portal-training-requirement-profile-audit>
        <sd-portal-aircraft-event-audit
          *ngSwitchCase="auditScreen.AircraftEvent"
        ></sd-portal-aircraft-event-audit>
        <sd-portal-staff-event-audit
          *ngSwitchCase="auditScreen.StaffEvent"
        ></sd-portal-staff-event-audit>
        <sd-portal-company-profile-audit
          *ngSwitchCase="auditScreen.CompanyProfile"
        ></sd-portal-company-profile-audit>
        <sd-portal-trip-audit *ngSwitchCase="auditScreen.ScheduledTrip"></sd-portal-trip-audit>
        <sd-portal-trip-audit
          *ngSwitchCase="auditScreen.DeletedTrips"
          [getDeletedTrips]="true"
        ></sd-portal-trip-audit>
        <sd-portal-trip-manager-audit
          *ngSwitchCase="auditScreen.TripManager"
        ></sd-portal-trip-manager-audit>
        <sd-portal-posted-flight-audit
          *ngSwitchCase="auditScreen.PostedFlight"
        ></sd-portal-posted-flight-audit>
        <sd-portal-simulated-flight-audit *ngSwitchCase="auditScreen.SimulatedFlight">
        </sd-portal-simulated-flight-audit>
        <sd-portal-expense-audit *ngSwitchCase="auditScreen.Expense"></sd-portal-expense-audit>
        <sd-portal-deleted-expense-audit-list *ngSwitchCase="auditScreen.DeletedExpenses">
        </sd-portal-deleted-expense-audit-list>
        <sd-portal-fleet-overview-audit *ngSwitchCase="auditScreen.FleetOverview">
        </sd-portal-fleet-overview-audit>
        <sd-portal-user-management-audit *ngSwitchCase="auditScreen.UserManagement">
        </sd-portal-user-management-audit>
        <sd-portal-role-management-audit *ngSwitchCase="auditScreen.RoleManagement">
        </sd-portal-role-management-audit>
      </ng-container>
    </div>
  </mat-drawer>
</mat-drawer-container>
